import { DropDownData } from "./DropDownData";

export const dataDropDown: DropDownData[] = [
  {
    name: "Book Now",
    link: "https://booking.staylist.app/Hideaway",
    target: "_blank",
  },
  {
    name: "Experience",
    link: "/experience",
    target: "_self",
  },
  {
    name: "Picturebook",
    link: "/picture-book",
    target: "_self",
  },
  {
    name: "Luxuries",
    link: "/luxuries",
    target: "_self",
  },
  {
    name: "Attractions",
    link: "/luxuries#attractions",
    target: "_self",
  },
  {
    name: "Camp Map",
    link: "/for-your-trip#campmap",
    target: "_self",
  },
  {
    name: "For Your Trip",
    link: "/for-your-trip",
    target: "_self",
  },
  // {
  //   name: "Hideaway Gogo",
  //   link: "https://hideawaygogo.com/",
  // },
];
